import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

const getActionsCss = css`
  padding: var(--cds-spacing-400) var(--cds-spacing-200) var(--cds-spacing-200);

  ${breakpoints.up('sm')} {
    padding: var(--cds-spacing-400) var(--cds-spacing-400) 0;
  }

  ${breakpoints.up('md')} {
    padding: var(--cds-spacing-600) var(--cds-spacing-600) 0;
  }
`;

export default getActionsCss;
